import React from 'react';
import './HomeProcess.css';

const HomeProcess = () => {
  const processSteps = [
    {
      num: "01",
      phase: "ASSESS",
      stageLabel: "Phase 01",
      title: "Understand the Institution",
      desc: "Initial requirement assessment and identification of existing capabilities and institutional gaps.",
      deliverable: "Gap Audit & Feasibility Review",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <circle cx="11" cy="11" r="8"/>
          <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          <line x1="11" y1="8" x2="11" y2="14"/>
          <line x1="8" y1="11" x2="14" y2="11"/>
        </svg>
      )
    },
    {
      num: "02",
      phase: "PLAN",
      stageLabel: "Phase 02",
      title: "Develop the Roadmap",
      desc: "Structured planning across academic, Teaching Hospital, infrastructure, manpower, and documentation requirements.",
      deliverable: "Strategic Institutional Roadmap",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/>
          <line x1="8" y1="2" x2="8" y2="18"/>
          <line x1="16" y1="6" x2="16" y2="22"/>
        </svg>
      )
    },
    {
      num: "03",
      phase: "PREPARE",
      stageLabel: "Phase 03",
      title: "Build Readiness",
      desc: "Coordination of departmental, hospital, manpower, clinical material, and documentation preparedness.",
      deliverable: "Hospital & Academic Synchronization",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <polyline points="9 12 11 14 15 10"/>
        </svg>
      )
    },
    {
      num: "04",
      phase: "EXPAND",
      stageLabel: "Phase 04",
      title: "Support Academic Growth",
      desc: "Structured support for MBBS Seat Expansion, New PG (MD/MS) Courses, and PG Seat Expansion.",
      deliverable: "Undergraduate & PG Expansion",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
          <polyline points="17 6 23 6 23 12"/>
        </svg>
      )
    },
    {
      num: "05",
      phase: "STRENGTHEN",
      stageLabel: "Phase 05",
      title: "Address Institutional Gaps",
      desc: "Readiness review, gap identification, statutory checklist verification, and corrective planning.",
      deliverable: "Checklist Verification & Mock Audit",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      )
    },
    {
      num: "06",
      phase: "SUPPORT",
      stageLabel: "Phase 06",
      title: "Build Academic Manpower",
      desc: "Permanent & Full-Time Medical Faculty Recruitment and professional Candidate–Institution coordination.",
      deliverable: "Verified Full-Time Faculty Staffing",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )
    }
  ];

  return (
    <section className="home-process-section-wrapper">
      
      {/* Subtle Background Glow */}
      <div className="home-process-section-ambient-glow"></div>

      <div className="home-process-section-container">
        
        {/* ================= SECTION HEADER ================= */}
        <div className="home-process-section-header">
          <div className="home-process-section-eyebrow">
            <span className="home-process-section-eyebrow-line"></span>
            <span>Our Institutional Approach</span>
            <span className="home-process-section-eyebrow-line"></span>
          </div>
          
          <h2 className="home-process-section-title">
            From Concept to Institutional Readiness
          </h2>
          
          <p className="home-process-section-subtitle">
            A defined six-stage institutional framework guiding medical colleges and teaching hospitals across project milestones.
          </p>
        </div>

        {/* ================= 6-STAGE SEQUENTIAL ROADMAP ================= */}
        <div className="home-process-section-grid">
          {processSteps.map((step, idx) => (
            <div key={idx} className="home-process-section-card">
              
              {/* Background Watermark Number for Depth */}
              <span className="home-process-section-card-watermark">{step.num}</span>

              {/* Card Top Row */}
              <div className="home-process-section-card-top">
                <div className="home-process-section-node">
                  <span className="home-process-section-node-num">{step.num}</span>
                </div>
                
                <div className="home-process-section-tags-wrap">
                  <span className="home-process-section-stage-label">{step.stageLabel}</span>
                  <span className="home-process-section-phase-badge">{step.phase}</span>
                </div>

                <div className="home-process-section-icon-box">
                  {step.icon}
                </div>
              </div>

              {/* Card Content */}
              <div className="home-process-section-card-content">
                <h3 className="home-process-section-card-title">{step.title}</h3>
                <p className="home-process-section-card-desc">{step.desc}</p>
              </div>

              {/* Key Deliverable Footer */}
              <div className="home-process-section-card-footer">
                <div className="home-process-section-deliverable-chip">
                  <span className="home-process-section-check">✓</span>
                  <span>{step.deliverable}</span>
                </div>
              </div>

              {/* Hover Top Glow Line */}
              <div className="home-process-section-card-hover-line"></div>
            </div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default HomeProcess;